import { render, staticRenderFns } from "./AccidentIntakeReviewSubmitForm.vue?vue&type=template&id=523bd4a1&scoped=true"
import script from "./AccidentIntakeReviewSubmitForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeReviewSubmitForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeReviewSubmitForm.vue?vue&type=style&index=0&id=523bd4a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523bd4a1",
  null
  
)

export default component.exports